import style from './Dashboard.module.css';
import { useState } from 'react';

const Dashboard = ({}) => {
  return <div>Dashboard</div>;
};

export default Dashboard;
